import { RoleEnum } from '@shared/enums/role.enum';

export const AOS_ROLES = [
  RoleEnum.BusinessAdmin, RoleEnum.BusinessStaff, RoleEnum.PersonalAdmin, RoleEnum.PersonalStaff
];

export const CRM_ROLES = [
  RoleEnum.CrmAdmin, RoleEnum.CrmUser
];
